import { useNavigate, useSearchParams } from "react-router-dom";
import DemoChrome from "./DemoChrome";
import "./bookDemo.css";

export default function BookDemoSuccessPage() {
  const navigate = useNavigate();
  const [params] = useSearchParams();
  const token = params.get("token") || "";

  return (
    <DemoChrome backLabel="Back to Home">
      <div className="bd-card bd-card--confirm">
        <div className="bd-success-icon" aria-hidden="true">
          <svg width="36" height="36" viewBox="0 0 52 52" fill="none">
            <circle cx="26" cy="26" r="25" stroke="currentColor" strokeWidth="2" />
            <path d="M16 26l8 8 12-16" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round" />
          </svg>
        </div>

        <h1 className="bd-title" style={{ fontSize: "1.65rem", marginBottom: "0.75rem" }}>
          Thank You for Your Interest!
        </h1>

        <p className="bd-subtitle" style={{ marginBottom: "1.5rem" }}>
          We&apos;ve received your demo request.
          <br />
          Our sales team will contact you shortly to arrange a convenient demo.
        </p>

        {token ? (
          <button
            type="button"
            className="bd-submit"
            onClick={() => navigate(`/book-demo/schedule/${encodeURIComponent(token)}`)}
          >
            Schedule a Demo Now
          </button>
        ) : null}

        <p className="bd-hint" style={{ marginTop: "1rem" }}>
          You can also wait for our sales team to contact you.
        </p>
      </div>
    </DemoChrome>
  );
}
